(function (angular) {
    angular
        .module('one.admin')
        .controller('AddLineModuleModalController', AddLineModuleModalController);

    AddLineModuleModalController.$inject = ['$scope', '$uibModalInstance', 'ModuleService', 'params'];

    function AddLineModuleModalController($scope, $uibModalInstance, ModuleService, params) {
        $scope.module = {
            module_instance: {
                brand: 'default'
            }
        };

        angular.merge($scope, params);

        $scope.addLineModule = addLineModule;

        $scope.cancel = cancel;

        function addLineModule(data) {
            ModuleService.addModule(data).then(function (data) {
                $uibModalInstance.close(data);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})(angular);
